import React, { Fragment } from 'react';
import { Row, Col, Button } from 'antd';
import { UsergroupAddOutlined } from '@ant-design/icons';

import Header from '@sharedComponent/header/header';
import { isAuth } from '@helpers';
import { commissionProfileAction } from '@constants';
import AppLoader from '@sharedComponent/loaders/app-loader';

const CommissionProfilesPresentational = ({ history, userDetails, data = [], commissionProfilesData = [], commissionProfilesLoading }) => {
	return (
		<Row className="commission_profile_container">
			<Col xl={24}>
				<Header title="Dashboard / Commission Profiles" />
			</Col>
			<Col xl={24} className="commission_profile_box">
				<Row className="commission_profile_title_area">
					<Col className="commission_title">Commission Profiles</Col>
					{isAuth(commissionProfileAction, userDetails && userDetails.accessLevel) ? (
						<>
							<Col className="commission_title_button" onClick={() => history.push('/campaign/add')}>
								<UsergroupAddOutlined /> ADD CAMPAIGN
							</Col>
						</>
					) : null}
				</Row>

				<Col className="com_body">
					{commissionProfilesLoading ? (
						<Col style={{ minHeight: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							<AppLoader width="5%" height="15%" />
						</Col>
					) : (
							<>
								{data.length > 0 ? (
									<table className="com_tab">
										<thead>
											<tr>
												<th style={{ width: '20%' }}>Campaign</th>
												<th style={{ width: '20%' }}>CPC</th>
												<th style={{ width: '20%' }}>Step 1 </th>
												<th style={{ width: '20%' }}>Step 2 </th>
												{isAuth(commissionProfileAction, userDetails && userDetails.accessLevel) ? (
													<>
														<th style={{ width: '10%' }}> </th>
														<th style={{ width: '10%' }}> </th>
													</>
												) : null}
											</tr>
										</thead>
										<tbody>
											{data.map((campaign, i) => (
												<Fragment>
													<Col style={{ margin: '6px' }}></Col>
													<tr>
														<td>{campaign.campaignName}</td>
														<td>${campaign.cpcCommission}</td>
														<td>${campaign.step1Commission}</td>
														<td>${campaign.step2Commission} </td>
														{isAuth(commissionProfileAction, userDetails && userDetails.accessLevel) ? (
															<>
																<td>
																	<Button onClick={() => history.push('/campaign/edit')} className="edit_btn">
																		Edit
																</Button>
																</td>
																<td>
																	<Button className="commission_delete_btn">Delete</Button>
																</td>
															</>
														) : null}
													</tr>
													<Col style={{ margin: '6px' }}></Col>
												</Fragment>
											))}
										</tbody>
									</table>
								) : (
										<Col
											style={{
												display: 'flex',
												fontSize: '18px',
												justifyContent: 'center',
												alignItems: 'center',
												fontFamily: 'Gilroy-Semibold',
												height: '100%',
											}}>
											<span>No Commission Profiles</span>
										</Col>
									)}
							</>
						)}
				</Col>
			</Col>
		</Row>
	);
};

export default CommissionProfilesPresentational;
